import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { HttpClient } from '@angular/common/http';
import { CellEditingStoppedEvent, ICellRendererParams, IDateFilterParams, ColDef, ValueGetterParams, ValueFormatterParams, GridApi, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { Router } from '@angular/router';
import { LadingStatusModalComponent } from 'src/app/lading-status-modal/lading-status-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConsolidationDismantleService } from '../consolidation-dismantle.service';
import { DismantleConsolidationDialogComponent } from '../dismantle-consolidation-dialog.component';

@Component({
  selector: 'app-consolidation-row-details',
  templateUrl: './consolidation-row-details.component.html',
  styleUrls: ['./consolidation-row-details.component.scss']
})
export class ConsolidationRowDetailsComponent implements ICellRendererAngularComp {
  // Modal to add lading status
  @ViewChild(LadingStatusModalComponent) lading_status_modal!: LadingStatusModalComponent;
  isStatusModalOpen: boolean = false;
  openStatusModal(){ this.isStatusModalOpen = true; }
  closeStatusModal(){ this.isStatusModalOpen = false; location.reload() }

  public gridReady = false;
  public themeClass: string = "ag-theme-ulaap";

  lading_consolidation_uuid: string | null = null;
  lading_uuid: string | null = null;
  start_location: string | null = null;
  end_location: string | null = null;
  consolidation_id: number | null = null;

  orders: any[] = [];
  locations: {location: string; ladings: string[]}[] = [];

  showContent: boolean = false;

  public rowGroupPanelShow: "always" | "onlyWhenGrouping" | "never" = "onlyWhenGrouping";
  public autoGroupColumnDef: ColDef = {
    minWidth: 200,
  };

  change_status_form: FormGroup = this.fb.group({
    status: ['', Validators.required],
    date: [new Date(),Validators.required],
    time: ['00:00',Validators.required]
  });
  

  private onDismantled: () => void = () => {};

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    public dismantleService: ConsolidationDismantleService,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) { }

  openDismantleDialog(): void {
    if (!this.consolidation_id) return;
    this.dialog.open(DismantleConsolidationDialogComponent, {
      width: '720px', maxWidth: '95vw', maxHeight: '90vh',
      data: { consolidationId: this.consolidation_id }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.toastr.success(`Consolidation ${this.consolidation_id} dismantled. Original ladings preserved.`);
        this.onDismantled();
      }
    });
  }

  agInit(params: any): void {
    this.onDismantled = params.onDismantled || (() => {});
    console.log('params', params)
    this.lading_consolidation_uuid = params.data.lading_consolidation_uuid
    this.lading_uuid = params.data.lading_uuid
    this.start_location = params.data.shipper_locality
    this.end_location = params.data.consignee_locality
    this.consolidation_id = params.data.consolidation_id;


    if ((this.lading_uuid && this.lading_consolidation_uuid) || this.consolidation_id) {
      const url = `/api/consolidations/consolidations_subgrid.php?lading_consolidation_uuid=${this.lading_consolidation_uuid}&lading_uuid=${this.lading_uuid}&consolidation_id=${this.consolidation_id}`;
      console.log(url);
      this.http.get(url).subscribe((response: any) => {
        if (response) {
          //console.log(response)
          this.orders = response;
          for (const lading of this.orders){
            const delivery_location = lading['consignee_locality'] + ', ' + lading['consignee_region'];
            const location_index = this.locations.find(loc => loc.location === delivery_location);
            if ( location_index === undefined){
              const new_location = {
                location: delivery_location,
                ladings: [lading['alternate_reference']]
              }
              this.locations.push(new_location);
            }
            else{
              location_index.ladings.push(lading['alternate_reference']);
            }
          }
          console.log(this.locations)
        }
        this.showContent = true;
      })
    }
  }

  changeStatus(){

  }

  private gridApi!: GridApi;

  onGridReady(params: any) {
    setTimeout(() => {
      this.gridApi = params.api;
    }, 0);
    // this.gridApi.sizeColumnsToFit();
  }

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
  };

  filterParams: IDateFilterParams = {
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
      let dateAsString = cellValue;
      if (dateAsString == null)
        return -1;
      let dateParts = dateAsString.split("-");
      let cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2])
      );
      if(filterLocalDateAtMidnight.getTime() === cellDate.getTime()){
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight){
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight){
        return 1;
      }
      return 0;
    }
  }

  // headers for the products grid
  columnDefs: ColDef[] = [
    { headerName: 'Destination', rowGroup: true, hide: true,
      valueGetter: params => {
        if (params.data)
          return params.data.consignee_locality + ', ' + params.data.consignee_region;
        return null;
      }
    },
    //{ headerName: 'View', width: 100, cellRenderer: ViewChildOrderDetailsComponent },
    { field: 'alternate_reference', headerName: 'Order No.', cellRenderer: 'agGroupCellRenderer'},
    { field: 'lading_status', headerName: 'Lading Status'},
    { field: 'carrier_name', headerName: 'Carrier' },
    { field: 'pro_bill', headerName: 'Pro Bill' },
    { field: 'shipper_locality', headerName: 'Pickup City' },
    { field: 'shipper_region', headerName: 'Pickup Region' },
    { field: 'consignee_locality', headerName: 'Delivery City'},
    { field: 'consignee_region', headerName: 'Delivery Region' },
    { field: 'load_start', headerName: 'Pickup Date', filter: 'agDateColumnFilter',
      valueGetter: params => {
        if (params.data){
          const datetime = new Date(params.data.load_start);
          return datetime.toISOString().split('T')[0];
        }
        return null;
      },
      filterParams: this.filterParams
    },
    { field: 'load_end', headerName: 'Delivery Date', filter: 'agDateColumnFilter',
      valueGetter: params => {
        if (params.data){
          const datetime = new Date(params.data.load_end);
          return datetime.toISOString().split('T')[0];
        }
        return null;
      },
      filterParams: this.filterParams
     },
    { field: 'load_pallets', headerName: 'Pallets' },
    { field: 'load_length', headerName: 'Load Length' },
    { field: 'load_weight', headerName: 'Weight' },
    { field: 'delivery_status', headerName: 'P & D Status' },
    { field: 'lading_consolidation_uuid', headerName: 'Consolidation UUID', hide: true},
    { field: 'lading_uuid', headerName: 'Lading UUID', hide: true},
  ]

  refresh(params: any): boolean {
    return false;
  }

  clearFilter(){
    this.gridApi.setFilterModel(null);
    this.gridApi.onFilterChanged();
  }

}

@Component({
  selector: 'app-view-child-order-details',
  template: `<span matTooltip="View Order Details"><a matTooltip="View Order Details" [attr.href]="getOrderDetailsLink()"><i class="fa-solid fa-eye"></i></a></span>`,
})
export class ViewChildOrderDetailsComponent implements ICellRendererAngularComp {

  params: any;

  constructor(private router: Router) { }

  getOrderDetailsLink(): string {
    return `/full-order-details/${this.params.data.lading_uuid}`;
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    //console.log(params);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    return false;
  }

}

